
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.4 12.934l.003.01a.754.754 0 01.014.175v6.114a.767.767 0 01-.767.767H3.768A.767.767 0 013 19.233v-6.114a.757.757 0 01.015-.175l.002-.01a.786.786 0 01.017-.064c0-.004.002-.007.003-.011l.003-.007.002-.007.007-.02 2.302-6.14a.767.767 0 01.719-.498h2.302a.767.767 0 110 1.535h-1.77l-1.727 4.604h3.497c.424 0 .767.344.767.768v1.534h6.14v-1.534c0-.424.343-.768.767-.768h3.497l-1.727-4.604h-1.77a.767.767 0 110-1.535h2.302c.32 0 .606.199.718.498l2.303 6.14a.6.6 0 01.007.02l.002.007.003.008a.766.766 0 01.02.075z","fill":"#000"}}),_c('path',{attrs:{"d":"M8.779 9.741l3.1 2.991a.413.413 0 00.333.189c.127 0 .249-.07.333-.189l3.1-2.99a.657.657 0 00.07-.591c-.072-.197-.23-.323-.403-.323h-1.771V3.55c0-.304-.199-.551-.443-.551h-1.772c-.244 0-.443.247-.443.551v5.277H9.112c-.174 0-.332.125-.403.323a.657.657 0 00.07.59z","fill":"#0A0A0A"}})])
          )
        }
      }
    